var React = require('react');

function AngleDownIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12,18c-0.53,0-1.04-0.21-1.42-0.58L2.59,9.43c-0.78-0.78-0.78-2.05,0-2.84s2.05-0.78,2.84,0L12,13.18l6.57-6.59c0.78-0.78,2.05-0.78,2.84,0c0.78,0.78,0.78,2.05,0,2.84l0,0l-7.99,7.99C13.04,17.79,12.53,18,12,18z"}));
}

AngleDownIcon.defaultProps = {"data-dmid":"dm-angle-down-icon","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = AngleDownIcon;

AngleDownIcon.default = AngleDownIcon;
